
import React from 'react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";
import { ChevronDown, Globe } from "lucide-react";

interface CountryFilterProps {
  selectedCountry: string | null;
  onCountrySelect: (country: string) => void;
  countries: string[];
}

const CountryFilter: React.FC<CountryFilterProps> = ({
  selectedCountry,
  onCountrySelect,
  countries,
}) => {
  
  return (
    <div className="w-full sm:w-[200px]">
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="outline" className="w-full flex items-center justify-between gap-2">
            <Globe className="h-4 w-4" />
            <span className="flex-1 text-left truncate">{selectedCountry || 'Select Country'}</span>
            <ChevronDown className="h-4 w-4 opacity-50" />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="start" className="w-[200px] max-h-[250px] overflow-y-auto bg-white dark:bg-gray-800">
          {/* Render each country in the order they were passed in */}
          {countries.map((country) => (
            <DropdownMenuItem
              key={country}
              className="cursor-pointer"
              onClick={() => onCountrySelect(country)}
            >
              {country}
            </DropdownMenuItem>
          ))}
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
};

export default React.memo(CountryFilter);
